import ScrollAnimation from 'react-animate-on-scroll';

const Contact = () => {
  return (
    <section id="contact">
      <ScrollAnimation animateOnce={true} animateIn="fadeInLeft" >
        <div className="header">
          <div className="headerText">
            <span>CONTACT</span>
            <ScrollAnimation animateOnce={true} className="headerBar" delay={500} animateIn="fadeInLeft">
            </ScrollAnimation>
          </div>
        </div>
      </ScrollAnimation>
        <ScrollAnimation className="contact-header" animateIn="fadeInUp" animateOnce={true}>
          <div className="contact-msg">Feel free to contact and discuss ideas.</div>
          <div className="contact-link">
            <a href="mailto:deepakmahajan269@gmail.com" target="_blank" rel="noreferrer">
              <span className="iconify link-icon" data-icon="fluent:mail-20-regular" data-inline="false"></span>
            </a>
            <a href="https://github.com/deepakMaj" target="_blank" rel="noreferrer">
            <span className="iconify link-icon" data-icon="akar-icons:github-fill" data-inline="false"></span>
            </a>
            <a href="https://www.linkedin.com/in/deepak-mahajan-nov1999" target="_blank" rel="noreferrer">
            <span className="iconify link-icon" data-icon="akar-icons:linkedin-fill" data-inline="false"></span>
            </a>
            <a href="https://www.facebook.com/deepakmahajan1999" target="_blank" rel="noreferrer">
            <span className="iconify link-icon" data-icon="akar-icons:facebook-fill" data-inline="false"></span>
            </a>
            <a href="https://www.instagram.com/deepakmahajan269" target="_blank" rel="noreferrer">
            <span className="iconify link-icon" data-icon="akar-icons:instagram-fill" data-inline="false"></span>
            </a>
          </div>
        </ScrollAnimation>
    </section>
  )
}

export default Contact;
